import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/jadwal-sholat/$kota")({
  component: () => <Outlet />,
});